// extracted by mini-css-extract-plugin
module.exports = {"voucherCode":"styles_voucherCode__31Pol","button":"styles_button__3utul","submitting":"styles_submitting__221qP","spinner":"styles_spinner__14xiz"};